// import { md5, md5Legacy, md5DarkLegacy } from '#build/antd-hash.mjs'
import { md5Legacy, md5DarkLegacy } from '#antd-hash'

export function useAntCss(theme: Ref<'light' | 'dark'>) {
  const runtimeConfig = useRuntimeConfig()

  if (import.meta.client) {
    if (isLegacyBrowser()) {
      useHead(
        {
          link: [
            {
              rel: 'stylesheet',
              href: `${runtimeConfig.app.cdnURL}/antd-${theme.value === 'light' ? md5Legacy : md5DarkLegacy}.css`,
            },
          ],
        },
        { tagPriority: -80 }
      )
    }
  }
}
